export default "__VITE_ASSET__wLbWP5bK__"